import { Locale, type LocalizedString } from "../Locale.js";
import type { Tenant } from "../Tenant.js";
import { getCartPath } from "./getCartPath.js";

const pathMap = {
	[Locale.cs]: "/fakturacni-udaje" as const,
	[Locale.en]: "/billing-information" as const,
} satisfies LocalizedString;

export function getCartAddressPath(tenant: Tenant): string {
	const prefix = getCartPath(tenant);
	return `${prefix}${pathMap[tenant.locale]}`;
}
